import React from 'react';
import { GroundTruthDocument } from '../../types';
import { Modal } from '../ui';

interface Props {
  document: GroundTruthDocument;
  onClose: () => void;
}

export const GroundTruthViewerModal: React.FC<Props> = ({ document, onClose }) => {
  return (
    <Modal isOpen={true} onClose={onClose} title={document.filename} size="lg">
      <p className="text-gray-600 mb-4">Domaine: {document.domain}</p>

        <div className="mb-4">
          <h3 className="font-medium mb-2">Données extraites (Ground Truth)</h3>
          <pre className="bg-gray-100 p-4 rounded overflow-x-auto text-sm">
            {JSON.stringify(document.expected_extraction, null, 2)}
          </pre>
        </div>

        <div className="text-sm text-gray-500">
          <p>Créé le: {new Date(document.created_at).toLocaleString('fr-CA', {
            timeZone: 'America/Montreal'
          })}</p>
          {document.source_reference && (
            <p className="mt-1">Référence: {document.source_reference}</p>
          )}
          {document.skip_benchmark && (
            <p className="mt-1 text-yellow-600">⚠️ Exclu des benchmarks{document.skip_reason && `: ${document.skip_reason}`}</p>
          )}
        </div>
    </Modal>
  );
};
